export default function productMediaSliderController() {
  const productMediaSlider = document.querySelector('.product-media-slider');

  if (!productMediaSlider) return;

  const swiperThumbs = new Swiper('.product-media-slider .swiper-thumbs', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    centeredSlides: true,
    centeredSlidesBounds: true,
    slideToClickedSlide: true,
    spaceBetween: 6,
    watchSlidesProgress: true,
    // freeMode: {
    //   enabled: true,
    //   // sticky: true,
    // },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 0.5,
    },
    breakpoints: {
      990: {
        direction: 'vertical',
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: '.thumbs-next',
      prevEl: '.thumbs-prev',
    },
  });

  const swiperMain = new Swiper('.product-media-slider .swiper-main', {
    spaceBetween: 10,
    slidesPerView: 1,
    thumbs: {
      swiper: swiperThumbs,
    },
    navigation: {
      nextEl: '.main-next',
      prevEl: '.main-prev',
    },
    on: {
      slideChange: function () {
        swiperThumbs.slideTo(this.activeIndex, 300);
        setTagsVisibility(this.activeIndex);

        // check if current slide is a video than play and stop all other videos
        const currentSlide = this.slides[this.activeIndex];
        const videos = currentSlide.querySelectorAll('video');
        if (videos.length > 0) {
          videos.forEach((video) => {
            if (video.paused) {
              video.play();
            }
          });
        } else {
          // If no video, pause all videos in other slides
          this.slides.forEach((slide) => {
            const slideVideos = slide.querySelectorAll('video');
            slideVideos.forEach((video) => {
              video.pause();
            });
          });
        }
      },
    },
  });

  function setTagsVisibility(activeIndex) {
    const showTags = activeIndex === 0;

    const tagsElement = document.querySelector('product-info .product-card__tags');
    if (tagsElement) {
      tagsElement.classList.toggle('is-hidden', !showTags);
    }
  }

  setTimeout(() => {
    swiperThumbs.slideTo(0);
  }, 50);

  const galleryContainer = document.getElementById('product-media-slider-gallery');

  if (galleryContainer) {
    const gLightBox = GLightbox({
      selector: '.product-media-slider .magnifier',
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });

    let lastActiveLightboxIndex = 0;
    gLightBox.on('slide_before_load', () => {
      const currentSlide = swiperMain.slides[swiperMain.activeIndex];
      const videos = currentSlide.querySelectorAll('video');
      if (videos.length > 0) {
        videos.forEach((video) => {
          video.pause();
        });
      }
    });
    gLightBox.on('slide_changed', ({ current }) => {
      lastActiveLightboxIndex = current.index;
    });
    gLightBox.on('close', (event) => {
      swiperMain.slideTo(lastActiveLightboxIndex);
    });
  }
}
